import {
    GET_FURNITURE_RECIPES_LOADING,
    GET_FURNITURE_RECIPES_SUCCESS,
    GET_FURNITURE_RECIPES_FAILURE
} from '../actionTypes'
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { getRecursivelyAsync } from '../../utils/get-recursively-async';

export const getFurnitureRecipesSuccess = payload => ({
    type: GET_FURNITURE_RECIPES_SUCCESS,
    payload
})

export const getFurnitureRecipesFailure = () => ({
    type: GET_FURNITURE_RECIPES_FAILURE
})

export const getFurnitureRecipesAsync = payload => dispatch => {
    return dispatch(getRecursivelyAsync('furniture-recipes', getFurnitureRecipesSuccess, 0));
}